document.addEventListener('DOMContentLoaded', function () {
  const tourSelections = [
    { container: '.holiday-tours', childIndex: 4 },
    { container: '.lunch-tours', childIndex: 5 },
    { container: '.standard-tours-90', childIndex: 8 },
    { container: '.calf-cuddling', childIndex: 11 }
  ];

  tourSelections.forEach(tour => {
    const section = document.querySelector(tour.container);
    if (!section) return;

    const optionInput = section.querySelector(`.single-option-selector__wrap-option:nth-child(${tour.childIndex}) input[type="radio"]`);
    if (optionInput) {
      optionInput.checked = true;
      const event = new Event('change', { bubbles: true });
      optionInput.dispatchEvent(event);
    }
  });
});